<template>
    <div class="message-list">
        <mt-header fixed title="消息列表">
            <router-link to="/" slot="left">
                <mt-button icon="back">返回</mt-button>
            </router-link>
        </mt-header>
        <div class="elder-form">
            <mt-navbar v-model="selected">
                <mt-tab-item id="0">未读消息</mt-tab-item>
                <mt-tab-item id="1">已读消息</mt-tab-item>
            </mt-navbar>
            <div class="message-list-body">
                <mt-tab-container v-model="selected">
                    <mt-tab-container-item id="0">

                        <ul class="mui-table-view message-list" v-infinite-scroll="loadMore" infinite-scroll-disabled="moreLoading" infinite-scroll-distance="0" infinite-scroll-immediate-check="false">
                            <!--li数据遍历循环部分-->
                            <li class="mui-table-view-cell message-block" v-for="item in messageList" @click="enterMessage(item.id)">
                                <span :class="'message-top-text '+importance_class[item.importance]+' has_read_label_'+item.has_read">{{ importance_name[item.importance] }}</span>
                                <div class="message-block-body">
                                    <div :class="'message-block-title has_read_'+item.has_read">
                                        {{ item.title }}
                                        <!--    <span class="message-type">{{ type_text[item.type]}}</span>-->
                                    </div>
                                    <div class="message-block-info">
                                        {{ item.content }}
                                    </div>
                                    <div class="message-time">
                                        {{ item.created_at }}
                                    </div>
                                </div>
                            </li>
                            <!--底部判断是加载图标还是提示“全部加载”-->
                            <li class="more_loading" v-show="queryLoading">
                                <mt-spinner class="spinner" type="fading-circle"  color="#ffcb01;" :size="25"></mt-spinner>
                            </li>
                            <li class="more_loading" v-show="!queryLoading">
                                <span class="loaded">已全部加载</span>
                            </li>
                        </ul>

                    </mt-tab-container-item>


                    <mt-tab-container-item id="1">

                        <ul class="mui-table-view message-list" v-infinite-scroll="loadMore" infinite-scroll-disabled="moreLoading" infinite-scroll-distance="0" infinite-scroll-immediate-check="false">
                            <!--li数据遍历循环部分-->
                            <li class="mui-table-view-cell message-block" v-for="item in messageList" @click="enterMessage(item.id)">
                                <span :class="'message-top-text '+importance_class[item.importance]+' has_read_label_'+item.has_read">{{ importance_name[item.importance] }}</span>
                                <div class="message-block-body">
                                    <div :class="'message-block-title has_read_'+item.has_read">
                                        {{ item.title }}
                                        <!--    <span class="message-type">{{ type_text[item.type]}}</span>-->
                                    </div>
                                    <div class="message-block-info">
                                        {{ item.content }}
                                    </div>
                                    <div class="message-time">
                                        {{ item.created_at }}
                                    </div>
                                </div>
                            </li>
                            <!--底部判断是加载图标还是提示“全部加载”-->
                            <li class="more_loading" v-show="queryLoading">
                                <mt-spinner class="spinner" type="fading-circle"  color="#ffcb01;" :size="25"></mt-spinner>
                            </li>
                            <li class="more_loading" v-show="!queryLoading">
                                <span class="loaded">已全部加载</span>
                            </li>
                        </ul>

                    </mt-tab-container-item>
                </mt-tab-container>
            </div>
        </div>
    </div>

</template>
<script>
    export default{
        data(){
            return {
                openid:JSON.parse(window.localStorage.getItem('UserInfo')).openid,
                selected:"0",

                //初始化无限加载相关参数
                messageList:[],
                queryLoading: true,
                pageNum:1,

                importance_name:['一般','重要','紧急'],
                importance_class:['message_normal','message_important','message_agent'],
                type_text:{'SEND':'人工消息','SYSTEM':'系统消息'}
            }
        },

        created(){
            this.getMessage(this.selected,this.pageNum);
        },

        watch:{
            selected:{
                handler(){
                    this.messageList = [];
                    this.queryLoading = true;
                    this.getMessage(this.selected,1,true);
                }
            }
        },

        methods:{
            getMessage(status,page,changed = false){
                this.$axios.post("/message/list", {openid:this.openid,page:page,has_read:this.selected})
                    .then(data => {

                        if (data.data.code === 'OK') {

                            if(changed){
                                this.messageList = data.data.data.data;
                            }else{
                                this.messageList = this.messageList.concat(data.data.data.data);
                            }

                            if(data.data.data.data.length<10){
                                this.queryLoading = false;
                            }
                        } else {
                            this.$toast(data.data.message);
                        }
                    });
            },

            enterMessage(id){
                this.$router.push('/message/'+id);
            },

            //无限加载函数
            loadMore() {

                if(!this.queryLoading){
                    return;
                }

                this.pageNum++;
                this.getMessage(this.selected,this.pageNum);

            },
        }
    }
</script>
<style scoped>
    .message-list-body{
        padding:10px 20px;
    }

    .message-title-header a{
        text-decoration:none;
    }

    .message-title-header span{
        font-size: 12px;
        color: #b4bbc0;
        padding: 3px 8px;
        border: 1px solid #b4bbc0;
        border-radius: 20px;
    }

    .message-block{
        background:#fff;
        margin-bottom:10px;
    }

    .message-block-body{
        padding:10px;
    }

    .message-top-text{
        font-size:12px;
        background:#ffcb01;
        color:#fff;
        padding:5px 8px;
        float: right;
    }

    .message-block-title{
        font-size:14px;
        padding:5px 0;
    }

    .message-block-info{
        font-size:12px;
        color: #848a8f;
    }

    .message-list-body{
        padding-bottom: 30px;
    }

    .message-time{
        font-size: 10px;
        color: #dedede;
        padding: 8px 0;
    }

    .message_normal{
        background:#4caf50;
    }

    .message_important{
        background:#26a2ff;
    }

    .message_agent{
        background:#ef4f4f;
    }

    .has_read_1{
        color:#888;
    }

    .has_read_label_1.message_normal{
        background:#dedede;
    }

    .has_read_label_1.message_important{
        background:#dedede;
    }

    .has_read_label_1.message_agent{
        background:#dedede;
    }

</style>


// WEBPACK FOOTER //
// src/pages/message/messageList.vue